import { ReactNode } from 'react';
import '../bpUtilStyle.css';

export const EntryField = ({
  children,
  label,
  required = undefined,
}: {
  children: ReactNode;
  label: string;
  required?: boolean;
}) => {
  const EntryStatusBatch = ({ required = false }: { required: boolean }) => {
    const label = required ? '必須' : '任意';
    return (
      <div className={`entry-status ${required ? 'required' : 'optional'}`}>
        <span>{label}</span>
      </div>
    );
  };

  return (
    <div className={'entry-field'}>
      <div className={'entry-field-header'}>
        <div className={'entry-label'}>
          <span>{label}</span>
        </div>
        {required !== undefined && <EntryStatusBatch required={required} />}
      </div>
      <div className={'entry-field-body'}>{children}</div>
    </div>
  );
};
